import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-black" data-testid="privacy-policy-page">
      <SEO title="Privacy Policy" description="Privacy Policy for Check On Yo Peoples TV, including cookies, ads, analytics, subscriptions, and contact details." type="website" />
      <Header />
      <div className="max-w-4xl mx-auto px-4 py-12 text-gray-300">
        <h1 className="text-3xl font-black text-white mb-2">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: September 2026</p>

        <div className="space-y-6 text-sm leading-relaxed">
          <section>
            <h2 className="text-white font-bold text-lg mb-2">Overview</h2>
            <p>Check On Yo Peoples TV ("we", "us", "our") operates coyp.me. This Privacy Policy explains what information we collect, how we use it, and your choices.</p>
          </section>

          <section>
            <h2 className="text-white font-bold text-lg mb-2">Information We Collect</h2>
            <p>When you subscribe to updates, we collect your name and email address. We also automatically collect standard usage data such as pages viewed, approximate location (via IP address), device/browser type, referral source, and general interaction data needed to keep the site working and understand readership trends.</p>
          </section>

          <section>
            <h2 className="text-white font-bold text-lg mb-2">Cookies &amp; Third-Party Advertising</h2>
            <p>We use cookies and similar technologies to operate the site and to serve relevant ads. We work with third-party advertising vendors, including Google AdSense, which use cookies to serve ads based on your prior visits to this site or other sites on the internet.</p>
            <p className="mt-2">You may opt out of personalized advertising by visiting <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer" className="text-yellow-500 hover:underline">Google's Ads Settings</a> or <a href="https://www.aboutads.info/choices" target="_blank" rel="noopener noreferrer" className="text-yellow-500 hover:underline">www.aboutads.info</a>.</p>
          </section>

          <section>
            <h2 className="text-white font-bold text-lg mb-2">Email, Push Notifications, and Communications</h2>
            <p>If you sign up for newsletters or browser notifications, we use your contact details or browser permission status to send updates you requested. You can unsubscribe from email messages or disable notifications in your browser settings at any time.</p>
          </section>

          <section>
            <h2 className="text-white font-bold text-lg mb-2">How We Use Information</h2>
            <p>We use collected information to operate and improve the site, publish and distribute content, send optional updates you sign up for, measure performance, prevent abuse, and understand how readers use our pages.</p>
          </section>

          <section>
            <h2 className="text-white font-bold text-lg mb-2">Third-Party Services</h2>
            <p>We may use third-party tools for analytics, advertising, content delivery, embedded media, and email or push delivery. These providers may process information according to their own privacy policies when you interact with their services through our site.</p>
          </section>

          <section>
            <h2 className="text-white font-bold text-lg mb-2">Data Retention</h2>
            <p>We keep information only as long as needed for site operations, legal obligations, analytics, audience communication, and business records. The exact retention period may vary by the type of data involved.</p>
          </section>

          <section>
            <h2 className="text-white font-bold text-lg mb-2">Children's Privacy</h2>
            <p>This site is not directed at children under 13, and we do not knowingly collect personal information from children under 13.</p>
          </section>

          <section>
            <h2 className="text-white font-bold text-lg mb-2">Your Rights &amp; Choices</h2>
            <p>Depending on where you live, you may have rights related to access, correction, deletion, or objection to certain data uses. You can contact us at any time to make a privacy-related request.</p>
          </section>

          <section>
            <h2 className="text-white font-bold text-lg mb-2">Security</h2>
            <p>We use reasonable administrative and technical safeguards intended to protect the information we collect. No method of transmission or storage is completely secure, but we work to reduce risk and maintain site integrity.</p>
          </section>

          <section>
            <h2 className="text-white font-bold text-lg mb-2">Contact Us</h2>
            <p>Questions about this policy? Reach us at <a href="mailto:contact@coyp.me" className="text-yellow-500 hover:underline">contact@coyp.me</a>.</p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
